import { render, staticRenderFns } from "./PoolClashUserProfile.vue?vue&type=template&id=c28ef1ee"
import script from "./PoolClashUserProfile.vue?vue&type=script&lang=js"
export * from "./PoolClashUserProfile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports